import React from 'react';
import "./Home.css";
import logo from "../../assets/images/saelv-app-logo.png";
import app_map from "../../assets/images/app-map.webp";
import app_details from "../../assets/images/app-details.webp";
import app_buy from "../../assets/images/app-buy.webp";
import apple_download from "../../assets/buttons/apple_black.svg";
import google_preregister from "../../assets/buttons/google_download.svg";
import AnimatedContent from "../../components/react-bits/AnimatedContent";

function Home() {
    return (
        <div className="home-container container">
            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0.1}
                animateOpacity={true}
                scale={1.05}
                threshold={0.2}
                delay={0.1}
            >
                <img src={logo} alt="Logo" className="logo-image"/>
                    
            </AnimatedContent>
            
            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                threshold={0.2}
                delay={0.1}
            >
                <h2 className="details-text">Din guide til tillidsstativer, gårdbutikker, vejboder og genbrug</h2>
            </AnimatedContent>

            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                threshold={0.2}
                delay={0.1}
            >
                <div className="download-container">
                    <div className="download-buttons">
                        <a href="https://apps.apple.com/dk/app/s%C3%A6lv/id6504734959" target="_blank" rel="noopener noreferrer"><img className="bn46"
                                                                                                                                      src={apple_download}
                                                                                                                                      alt="bn45"/>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=dk.saelv.android" target="_blank" rel="noopener noreferrer"><img className="bn45"
                                                                                                                                                src={google_preregister}
                                                                                                                                                alt="bn45"/>
                        </a>
                    </div>
                    <p className="available-txt">Tilgængelig på iPhone, iPad og til Android</p>
                </div>
            </AnimatedContent>

            <div className="app-image-container">
                <AnimatedContent
                    distance={50}
                    direction="vertical"
                    reverse={false}
                    duration={0.8}
                    ease="easeInOut"
                    initialOpacity={0}
                    animateOpacity={true}
                    scale={1.05}
                    delay={0.1}
                    threshold={0.1}
                >
                    <div className="app-image">
                        <h3>Overblik over Sælv</h3>
                        <img src={app_map} alt="App screenshot 1"/>
                    </div>
                </AnimatedContent>

                <AnimatedContent
                    distance={50}
                    direction="vertical"
                    reverse={false}
                    duration={0.8}
                    ease="easeInOut"
                    initialOpacity={0}
                    animateOpacity={true}
                    scale={1.05}
                    delay={0.1}
                    threshold={0.2}
                >
                    <div className="app-image">
                        <h3>Informationer om en Sælv</h3>
                        <img src={app_details} alt="App screenshot 2"/>
                    </div>
                </AnimatedContent>

                <AnimatedContent
                    distance={50}
                    direction="vertical"
                    reverse={false}
                    duration={0.8}
                    ease="easeInOut"
                    initialOpacity={0}
                    animateOpacity={true}
                    scale={1.05}
                    delay={0.1}
                    threshold={0.2}
                >
                    <div className="app-image">
                        <h3>Udregning af varer</h3>
                        <img src={app_buy} alt="App screenshot 3"/>
                    </div>
                </AnimatedContent>
            </div>
        </div>
    );
}

export default Home;